/**
 *    FUNCTION TO INIT ALL DATEPICKERS UNIFROMLY ON THE PAGE
 *
 *    HTML-Input needs class:       date-picker-input
 *    HTML-Input needs attribute:   data-language="{$webuser_lang}" | default: "DE"
 *
 *    possible input formats (validation):
 *    dd.mm.yyyy
 *    dd.mm.yy
 *    ddmmyyyy
 *    ddmmyy
 *
 *    Click-Event for Calendar-Icon
 *
 *    Change-Event for Calendar-Input:
 *    - validates the input
 *    - formats the input to dd.mm.yyyy
 *    - updates the datepicker-view
 */

$(document).ready(function () {
    if(!$.fn.datepicker)
        return;

    $.fn.datepicker.defaults.format             = 'dd.mm.yyyy';
    $.fn.datepicker.defaults.language           = $("input[type='hidden'][name='language']").val();
    $.fn.datepicker.defaults.autoclose          = true;
    $.fn.datepicker.defaults.todayHighlight     = true;
    $.fn.datepicker.defaults.todayBtn           = true;
    $.fn.datepicker.defaults.weekStart          = 1;

    if(typeof datepickerWeekendDaysEnabled == "undefined" || datepickerWeekendDaysEnabled == false){
        $.fn.datepicker.defaults.daysOfWeekDisabled = [0, 6];
    }

    initDatepicker($('.date-picker-input'));

    $('.input-group-addon').click(function () {
        $(this).next().focus();
    });
});

function initDatepicker(pickers) {
    $.each(pickers, function(i, el){
        let picker  = $(el);
        let lang    = picker.attr("data-language");

        $.fn.datepicker.defaults.format             = 'dd.mm.yyyy';
        if(lang != undefined && lang != '' && lang != 'null'){
            $.fn.datepicker.defaults.language           = lang;
        }

        picker.datepicker({format: "dd.mm.yyyy"});

        picker.on("change", function(e){
            let element     = $(e.target);
            let givenDate   = element.val();
            let storedDate  = element.attr("data-stored");

            if(storedDate == givenDate) return false;

            if(dateIsValid(givenDate)){
                let formattedDate = formatDate(givenDate);

                element.attr("data-stored", formattedDate);
                element.val(formattedDate);

                setTimeout(function(){
                    picker.datepicker("update", formattedDate);
                }, 50)
            }else{
                element.val("");
            }
        });
    });

    function dateIsValid(date){
        let regExp      = new RegExp(/[0-9]{1,2}[.]?[0-9]{1,2}[.]?[0-9]{2,4}$/); // allow only numbers and dots, dots are optional
        let countDots   = date.split(".").length == 3 || date.split(".").length == 1;

        return countDots && regExp.test(date);
    }

    function formatDate(date){
        let currentYear = new Date().getFullYear();

        if(date.indexOf('.') > -1){
            // if dots occure
            let splits = date.split(".");
            if(splits[2].length == 4) return date;

            splits[2]   = currentYear.toString().slice(0, 2) + "" + splits[2];
            date        = splits.join(".");
        }else{
            // if no dots occure
            let day     = date.slice(0,2);
            let month   = date.slice(2,4);

            if(date.length == 6){
                date = day + '.' + month + '.' + currentYear.toString().slice(0,2) + date.slice(4,6);
            }else{
                date = day + '.' + month + '.' + date.slice(4,8);
            }
        }

        return date;
    }
}